(function () {
  'use strict';

  var css = [
    '.pulse-cta{',
      'position:fixed;',
      'bottom:30px;',
      'left:0;',
      'z-index:9997;',
      'opacity:0;',
      'transform:translateX(-110%);',
      'transition:opacity 0.5s ease, transform 0.55s cubic-bezier(0.34,1.56,0.64,1);',
      'pointer-events:none;',
      'display:flex;',
      'align-items:center;',
    '}',
    '.pulse-cta.is-visible{',
      'opacity:1;',
      'transform:translateX(0);',
      'pointer-events:auto;',
    '}',

    /* Outer glow ring — purely visual */
    '.pulse-cta__ring{',
      'position:absolute;',
      'inset:-5px;',
      'left:0;',
      'border-radius:0 50px 50px 0;',
      'animation:pulse-ring 1.8s ease-out infinite;',
      'pointer-events:none;',
      'z-index:0;',
    '}',
    '@keyframes pulse-ring{',
      '0%  { box-shadow:0 0 0 0    rgba(var(--pc-r,220),var(--pc-g,30),var(--pc-b,30),0.6); }',
      '70% { box-shadow:0 0 0 16px rgba(var(--pc-r,220),var(--pc-g,30),var(--pc-b,30),0);  }',
      '100%{ box-shadow:0 0 0 0    rgba(var(--pc-r,220),var(--pc-g,30),var(--pc-b,30),0);  }',
    '}',

    /* LIVE pill button */
    '.pulse-cta__btn{',
      'position:relative;',
      'z-index:1;',
      'display:flex;',
      'align-items:center;',
      'gap:7px;',
      'padding:10px 18px 10px 16px;',
      'background:#111;',
      'color:#fff;',
      'font-family:inherit;',
      'font-size:0.78rem;',
      'font-weight:800;',
      'letter-spacing:0.1em;',
      'text-transform:uppercase;',
      'border:none;',
      'border-radius:0 50px 50px 0;',
      'cursor:pointer;',
      'white-space:nowrap;',
      'overflow:hidden;',
      'animation:pulse-bob 2.4s ease-in-out infinite;',
      'box-shadow:4px 4px 20px rgba(220,30,30,0.45);',
    '}',

    /* Left-to-right shimmer */
    '.pulse-cta__btn::after{',
      'content:"";',
      'position:absolute;',
      'inset:0;',
      'background:linear-gradient(90deg,transparent 0%,rgba(255,255,255,0.22) 50%,transparent 100%);',
      'background-size:220% 100%;',
      'background-position:-200% center;',
      'animation:shimmer-lr 2.2s ease-in-out infinite;',
      'border-radius:inherit;',
      'pointer-events:none;',
    '}',
    '@keyframes shimmer-lr{',
      '0%   { background-position:-200% center; }',
      '60%  { background-position: 200% center; }',
      '100% { background-position: 200% center; }',
    '}',
    '@keyframes pulse-bob{',
      '0%,100%{ transform:translateY(0px);  }',
      '50%    { transform:translateY(-5px); }',
    '}',
    '.pulse-cta__btn:hover{ opacity:0.88; }',
    '.pulse-cta__btn:active{ transform:scale(0.95) !important; }',

    /* Blinking red dot */
    '.pulse-cta__dot{',
      'width:9px;',
      'height:9px;',
      'border-radius:50%;',
      'background:#ff3b3b;',
      'flex-shrink:0;',
      'animation:dot-blink 1.1s ease-in-out infinite;',
    '}',
    '@keyframes dot-blink{',
      '0%,100%{ opacity:1;   transform:scale(1);    }',
      '50%    { opacity:0.25; transform:scale(0.7); }',
    '}',

    /* Dismiss × */
    '.pulse-cta__close{',
      'position:relative;',
      'z-index:1;',
      'display:flex;',
      'align-items:center;',
      'justify-content:center;',
      'width:22px;',
      'height:22px;',
      'margin-left:5px;',
      'background:rgba(0,0,0,0.35);',
      'border:none;',
      'border-radius:50%;',
      'color:#fff;',
      'font-size:13px;',
      'line-height:1;',
      'cursor:pointer;',
      'flex-shrink:0;',
      'padding:0;',
    '}',
    '.pulse-cta__close:hover{ background:rgba(0,0,0,0.6); }',

    '@media(max-width:749px){ .pulse-cta{ bottom:90px; } }'
  ].join('');

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // DOM — just the LIVE dot + text
  var wrapper = document.createElement('div');
  wrapper.className = 'pulse-cta';
  wrapper.innerHTML =
    '<div class="pulse-cta__ring"></div>' +
    '<button class="pulse-cta__btn" type="button" aria-label="Live — checkout now">' +
      '<span class="pulse-cta__dot"></span>' +
      'Live' +
    '</button>' +
    '<button class="pulse-cta__close" type="button" aria-label="Dismiss">×</button>';
  document.body.appendChild(wrapper);

  var btn   = wrapper.querySelector('.pulse-cta__btn');
  var close = wrapper.querySelector('.pulse-cta__close');

  // Show / hide
  var shown = false;
  function show() {
    if (shown) return;
    shown = true;
    wrapper.classList.add('is-visible');
    setTimeout(extractAndApply, 200);
  }
  close.addEventListener('click', function (e) {
    e.stopPropagation();
    wrapper.classList.remove('is-visible');
  });

  // Click → checkout
  btn.addEventListener('click', function () {
    window.location.href = '/checkout';
  });

  // Detect add-to-cart (3 methods)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.add-to-cart-button,[data-testid="add-to-cart"],[name="add"]')) {
      setTimeout(show, 1200);
    }
  }, true);

  ['cart:updated','cart-update','CartUpdate','cart:item-added'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(show, 600); });
    window.addEventListener(ev,   function () { setTimeout(show, 600); });
  });

  function watchCartCount() {
    var badge = document.querySelector('[data-cart-count],.cart-count,.cart-item-count,.header__cart-count');
    if (!badge) return;
    new MutationObserver(function () { setTimeout(show, 600); })
      .observe(badge, { childList:true, subtree:true, characterData:true });
  }
  watchCartCount();

  // Ambient colour
  function extractAndApply() {
    var img = document.querySelector('.media-gallery img,.product-information__media img,.product__media img');
    if (!img) return;
    var src = img.currentSrc || img.src || '';
    if (!src || src.indexOf('data:') === 0) return;
    var proxy = new Image();
    proxy.crossOrigin = 'anonymous';
    proxy.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = c.height = 40;
        var ctx = c.getContext('2d');
        ctx.drawImage(proxy,0,0,40,40);
        var px = ctx.getImageData(0,0,40,40).data;
        var best=null,bestScore=0;
        for (var i=0;i<px.length;i+=4){
          var r=px[i],g=px[i+1],b=px[i+2],a=px[i+3];
          if(a<200)continue;
          var mx=Math.max(r,g,b),mn=Math.min(r,g,b),d=mx-mn;
          if(d<25)continue;
          var l=(mx+mn)/510,s=d/Math.max(1,255*(1-Math.abs(2*l-1)));
          var sc=s*(1-Math.pow((l-0.45)*2.2,2));
          if(sc>bestScore){bestScore=sc;best=[r,g,b];}
        }
        if(best){
          wrapper.style.setProperty('--pc-r',Math.round(best[0]*0.72));
          wrapper.style.setProperty('--pc-g',Math.round(best[1]*0.72));
          wrapper.style.setProperty('--pc-b',Math.round(best[2]*0.72));
        }
      }catch(e){}
    };
    proxy.src=src.split('?')[0]+'?width=40&format=jpg';
  }

  if (document.readyState==='loading') {
    document.addEventListener('DOMContentLoaded',function(){setTimeout(extractAndApply,800);});
  } else {
    setTimeout(extractAndApply,800);
  }

})();
